<h4 class="m-0 text-lg font-bold text-default">
  {{ 'Absence type distribution' | translate }}
</h4>
<p class="text-sm font-semibold text-support">{{ startDate }} - {{ endDate }}</p>
@if (loading) {
  <sb-loading-state class="py-2xl" />
} @else {
  <sb-horizontal-stacked-bar-chart [items]="timeDistributionItems" />
}
